import { ParserHelper } from "../ParserHelper";
export class ScoreboardTennisParser {
    constructor() {
        this.scoresToDisplayForGamePart = { firstset: 1, secondset: 2, thirdset: 3, fourthset: 4, fifthset: 5 };
    }
    static get instance() {
        if (!ScoreboardTennisParser._instance) {
            ScoreboardTennisParser._instance = new ScoreboardTennisParser();
        }
        return ScoreboardTennisParser._instance;
    }
    parse(sportEvent, isTeamSwap) {
        let onServe = ParserHelper.instance.getAdditionalScore(sportEvent, "onServe");
        const currentTennisScores = this.currentTennisScores(sportEvent.score);
        let additionalScoreData1 = ParserHelper.instance.getAdditionalScores(sportEvent, currentTennisScores, "1");
        let additionalScoreData2 = ParserHelper.instance.getAdditionalScores(sportEvent, currentTennisScores, "2");
        if (isTeamSwap) {
            return {
                onServe: this.swapOnServe(onServe),
                additionalScoreData1: additionalScoreData2,
                additionalScoreData2: additionalScoreData1
            };
        }
        return {
            onServe,
            additionalScoreData1,
            additionalScoreData2
        };
    }
    swapOnServe(onServe) {
        switch (Number(onServe)) {
            case 1: return "2";
            case 2: return "1";
        }
        return undefined;
    }
    currentTennisScores(score) {
        if (!score) {
            return [];
        }
        return Object.keys(score.additionalScores)
            .filter(scoreKey => Object.keys(this.scoresToDisplayForGamePart).some(y => scoreKey.toLowerCase().indexOf(y) > -1) &&
            score.additionalScores[scoreKey] !== "0")
            .map(set => set.slice(0, set.length - 1))
            .filter((v, i, a) => a.indexOf(v) === i);
    }
}
;
//# sourceMappingURL=ScoreboardTennisParser.js.map